import React from 'react';
import { FileText } from 'lucide-react';

const FloatingCTA: React.FC = () => {
  const handleScrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  };

  return (
    <div className="fixed bottom-6 right-6 z-40">
      <button
        onClick={handleScrollToContact}
        className="group inline-flex items-center px-5 py-3 rounded-full bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 transition-all duration-300 font-bold shadow-2xl hover:shadow-3xl transform hover:scale-105"
        aria-label="Send us a message"
      >
        <FileText size={18} className="mr-2 group-hover:rotate-12 transition-transform duration-300" />
        <span>Send a Message</span>
      </button>
    </div>
  );
};

export default FloatingCTA;
